import HttpClient from './http-client';
import URL from './url';

export default class TestApi {

    static getTest(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST + "?" + params.join('&') : URL.TEST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getAssessmentQuestionList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_QUESTION_LIST + "?" + params.join('&') : URL.TEST_QUESTION_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getDiagnosticQuestionList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.DIAGNOSTIC_QUESTION_LIST + "?" + params.join('&') : URL.DIAGNOSTIC_QUESTION_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static createTest(payload) {
        return HttpClient.post(URL.BASE_URL + URL.TEST, null, payload);
    }

    static updateTest(payload) {
        return HttpClient.put(URL.BASE_URL + URL.TEST, null, payload);
    }

    static getTestCompletionReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_COMPLETION_REPORT + "?" + params.join('&') : URL.TEST_COMPLETION_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getTestResultReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_RESULT + "?" + params.join('&') : URL.TEST_RESULT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getStudentEvaluationReportPdf(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_EVALUATION_REPORT_PDF + "?" + params.join('&') : URL.TEST_EVALUATION_REPORT_PDF;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getTestWrongAnswersReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_WRONG_ANSWERS_REPORT + "?" + params.join('&') : URL.TEST_WRONG_ANSWERS_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getTestStatusWrongAnswersReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_STATUS_WRONG_ANSWERS_REPORT + "?" + params.join('&') : URL.TEST_STATUS_WRONG_ANSWERS_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getTestStudentDetailReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_STUDENT_DETAIL_REPORT + "?" + params.join('&') : URL.TEST_STUDENT_DETAIL_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getAllQuestionList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_ALL_QUESTIONS_REPORT + "?" + params.join('&') : URL.TEST_ALL_QUESTIONS_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getSchoolQuestionSet(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_SCHOOL_QUESTION_SET + "?" + params.join('&') : URL.GET_SCHOOL_QUESTION_SET;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static updateUserAssessmentActivity(payload) {
        return HttpClient.put(URL.BASE_URL + URL.USER_ASSESSMENT_ACTIVITY, null, payload);
    }

    static getTestEloReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_ELO_REPORT + "?" + params.join('&') : URL.TEST_ELO_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getStudentListForEloReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEST_ELO_REPORT_STUDENT_LIST + "?" + params.join('&') : URL.TEST_ELO_REPORT_STUDENT_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getAssessmentAllQuestionList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_SCHOOL_ASSESSMENT_QUESTIONS + "?" + params.join('&') : URL.GET_SCHOOL_ASSESSMENT_QUESTIONS;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    

    static createJigyasaAssessment(payload) {
        return HttpClient.post(URL.BASE_URL + URL.CREATE_ASSESSMENT, null, payload);
    }

    static createClickerQuiz(payload) {
        return HttpClient.post(URL.BASE_URL + URL.CREATE_CLICKER_QUIZ, null, payload);
    }

    static getQuestionListPdf(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_QUESTIONS_LIST_PDF + "?" + params.join('&') : URL.GET_QUESTIONS_LIST_PDF;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getQuestionSet(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_QUESTION_SET_LIST + "?" + params.join('&') : URL.GET_QUESTION_SET_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    

    
}